import React from 'react'
import './Style/Info.css'
function Info({data,location,info}) {
  return<div className='invoice-info'>
      <p> Invoice to :   </p>
      <span> {info.info.customerName} </span>

      <div className='info'>
          <div className='locations'>
            {location.map((item,key)=>(
              <p className='location'> {item} </p>
            ))}
            {/* <p className='location'> Building Name  </p>
            <p className='location'> Country </p> */}
          </div>
          <h1 className='invoiceheadings'>  INVOICE  </h1>
          <div className='date'>
              <div>
                {data.map((item,key)=>(
                  <p key={key} className='infopara'> {item.label} </p>
                ))}
              </div>
              <div>
                {data.map((item,key)=>(
                  <p key={key} className='infopara'> : {item.value} </p>
                ))}
              </div>
          </div>
      </div>

      <p className='product-name'> Product Name :  {info.info.productName} </p>

  </div>
}

export default Info